import { RiskClassificationLevel } from '@indigo-ag/schema';
import { ContactRiskClassificationItem } from '../../../phases/Phase1.utils';
import i18next from 'i18next';
import { date } from 'shared';
import { palettes } from '@indigo-ag/component-module';

export const MAX_RISK_CLASSIFICATION_MONTHS = 6;

export const getInfoText = (riskClassification: ContactRiskClassificationItem) => {
  if (!riskClassification || riskClassification.riskClassificationLevel === RiskClassificationLevel.NOT_CLASSIFIED) {
    return i18next.t('preAnalysisRiskLevel-risk-classification-not-classified');
  }
  if (riskClassification.isExpired) {
    return i18next.t('preAnalysisRiskLevel-risk-classification-expired');
  }
  return i18next.t('preAnalysisRiskLevel-risk-classification-not-expired');
};

export const getTooltipText = (riskClassification: ContactRiskClassificationItem) => {
  if (!riskClassification || riskClassification.riskClassificationLevel === RiskClassificationLevel.NOT_CLASSIFIED) {
    return i18next.t('preAnalysisRiskLevel-risk-classification-not-classified-tooltip');
  }
  if (riskClassification.isExpired) {
    return i18next.t('preAnalysisRiskLevel-risk-classification-expired-tooltip');
  }
  return i18next.t('preAnalysisRiskLevel-risk-classification-not-expired-tooltip', {
    value: date.addMonths(riskClassification?.classificationDate, MAX_RISK_CLASSIFICATION_MONTHS)
  });
};

export const getInfoTextColor = (riskClassification: ContactRiskClassificationItem) => {
  if (!riskClassification || riskClassification.riskClassificationLevel === RiskClassificationLevel.NOT_CLASSIFIED) {
    return palettes.brand.yellow.dark;
  }
  if (riskClassification.isExpired) {
    return palettes.brand.red.base;
  }
  return palettes.brand.blue.base;
};
